(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-ugc-gallery';

  function initSection(section) {
    if (!section || section.dataset.odditCarouselReady === 'true') return;
    section.dataset.odditCarouselReady = 'true';

    var track = section.querySelector('.oddit-section-ugc-gallery__track');
    var slides = section.querySelectorAll('.oddit-section-ugc-gallery__card');
    var controls = section.querySelector('.oddit-section-ugc-gallery__controls');
    var dotsContainer = section.querySelector('.oddit-section-ugc-gallery__dots');
    var prevBtn = section.querySelector('[data-ugc-prev]');
    var nextBtn = section.querySelector('[data-ugc-next]');

    if (!track || !slides.length) return;

    var dotTargets = [];

    function getStep() {
      // Distance to advance per arrow click = first slide width + flex gap.
      if (slides.length < 2) {
        return slides[0] ? slides[0].getBoundingClientRect().width : 0;
      }
      var first = slides[0].getBoundingClientRect();
      var second = slides[1].getBoundingClientRect();
      return Math.max(0, second.left - first.left);
    }

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function computeDotTargets() {
      var step = getStep();
      var max = getMaxScroll();
      var targets = [0];
      if (step > 0 && max > 0) {
        // Each subsequent dot advances one slide-step until we cover max.
        // Cap the count at the slide count so we never produce more dots
        // than there are slides.
        var pos = step;
        while (pos < max && targets.length < slides.length - 1) {
          targets.push(pos);
          pos += step;
        }
        targets.push(max);
      }
      return targets;
    }

    function rebuildDots() {
      if (!dotsContainer) return;
      dotTargets = computeDotTargets();

      // Hide the dots row entirely when the carousel can't scroll
      if (dotTargets.length <= 1) {
        dotsContainer.innerHTML = '';
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = '';

      // Reuse existing dot buttons where possible to avoid event-listener churn
      while (dotsContainer.children.length > dotTargets.length) {
        dotsContainer.removeChild(dotsContainer.lastElementChild);
      }
      while (dotsContainer.children.length < dotTargets.length) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'oddit-section-ugc-gallery__dot';
        dot.setAttribute('data-ugc-dot', '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-selected', 'false');
        var idx = dotsContainer.children.length;
        dot.addEventListener('click', (function (capturedIndex) {
          return function () { scrollToDotIndex(capturedIndex); };
        })(idx));
        dotsContainer.appendChild(dot);
      }

      for (var i = 0; i < dotsContainer.children.length; i++) {
        var btn = dotsContainer.children[i];
        btn.setAttribute('data-slide-index', String(i));
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      }

      updateDots();
    }

    function updateArrowState() {
      var max = getMaxScroll();
      // Hide the whole controls row when there's nothing to scroll past
      if (controls) {
        controls.classList.toggle('oddit-section-ugc-gallery__controls--idle', max <= 0);
      }
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 1;
    }

    function updateDots() {
      if (!dotsContainer) return;
      var dots = dotsContainer.querySelectorAll('[data-ugc-dot]');
      if (!dots.length || !dotTargets.length) return;

      // Active dot = closest target to the current scroll position
      var current = track.scrollLeft;
      var activeIndex = 0;
      var closestDist = Infinity;
      for (var i = 0; i < dotTargets.length; i++) {
        var dist = Math.abs(current - dotTargets[i]);
        if (dist < closestDist) {
          closestDist = dist;
          activeIndex = i;
        }
      }

      for (var j = 0; j < dots.length; j++) {
        var isActive = j === activeIndex;
        dots[j].classList.toggle('oddit-section-ugc-gallery__dot--active', isActive);
        dots[j].setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
    }

    function scrollByStep(direction) {
      var step = getStep();
      if (!step) return;
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    function scrollToDotIndex(index) {
      if (index < 0 || index >= dotTargets.length) return;
      track.scrollTo({ left: dotTargets[index], behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByStep(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByStep(1);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        updateArrowState();
        updateDots();
      },
      { passive: true }
    );

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        rebuildDots();
        updateArrowState();
      });
      ro.observe(track);
    } else {
      window.addEventListener('resize', function () {
        rebuildDots();
        updateArrowState();
      });
    }

    // Initial sync after layout settles
    requestAnimationFrame(function () {
      rebuildDots();
      updateArrowState();
    });

    // Wire up any video cards inside this section
    var videoWraps = section.querySelectorAll('[data-ugc-video-wrap]');
    for (var v = 0; v < videoWraps.length; v++) {
      initVideoCard(videoWraps[v]);
    }

    // Mouse/pen drag scrolling on desktop (touch keeps native overflow scroll)
    initDragScroll(track);
  }

  function initDragScroll(track) {
    var DRAG_THRESHOLD = 5;       // px before we treat motion as a drag
    var FRICTION = 0.93;          // velocity decay per ~16ms frame
    var MIN_VELOCITY = 0.02;      // px per ms — below this we stop the loop
    var DRAGGING_CLASS = 'oddit-section-ugc-gallery__track--dragging';

    var isDown = false;
    var activePointerId = null;
    var startX = 0;
    var startScrollLeft = 0;
    var dragged = false;
    var prevScrollBehavior = '';

    var lastT = 0;
    var lastScrollLeft = 0;
    var velocity = 0;             // scrollLeft px per ms; positive = scrolling right
    var momentumRaf = null;

    function shouldIgnore(e) {
      if (e.pointerType === 'touch') return true;
      // Don't initiate drag-scroll from inside an interactive control or
      // a video card. Otherwise the 5px motion threshold can flip
      // wasDragged on a normal click, and the blockClick listener
      // (capture phase + stopPropagation) eats the click before it
      // reaches the quick-view trigger / video wrap / link.
      if (
        e.target.closest &&
        e.target.closest(
          '[data-ugc-video-wrap], [data-oddit-quickshop-trigger], a, button, input, select, textarea, [role="button"]'
        )
      ) {
        return true;
      }
      return false;
    }

    function cancelMomentum() {
      if (momentumRaf !== null) {
        cancelAnimationFrame(momentumRaf);
        momentumRaf = null;
      }
      velocity = 0;
    }

    function startMomentum() {
      if (Math.abs(velocity) < MIN_VELOCITY) {
        track.classList.remove(DRAGGING_CLASS);
        return;
      }
      var lastFrame = performance.now();
      var step = function (now) {
        var dt = now - lastFrame;
        lastFrame = now;
        track.scrollLeft += velocity * dt;
        // Clamp at edges so we don't fight the scroll container forever
        if (track.scrollLeft <= 0 || track.scrollLeft >= track.scrollWidth - track.clientWidth) {
          velocity = 0;
        } else {
          velocity *= Math.pow(FRICTION, dt / 16);
        }
        if (Math.abs(velocity) > MIN_VELOCITY) {
          momentumRaf = requestAnimationFrame(step);
        } else {
          momentumRaf = null;
          track.classList.remove(DRAGGING_CLASS);
        }
      };
      momentumRaf = requestAnimationFrame(step);
    }

    track.addEventListener('pointerdown', function (e) {
      if (shouldIgnore(e)) return;
      if (e.button !== undefined && e.button !== 0) return;

      cancelMomentum();
      isDown = true;
      activePointerId = e.pointerId;
      startX = e.clientX;
      startScrollLeft = track.scrollLeft;
      dragged = false;

      lastT = performance.now();
      lastScrollLeft = track.scrollLeft;
      velocity = 0;

      prevScrollBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.classList.add(DRAGGING_CLASS);

      try { track.setPointerCapture(e.pointerId); } catch (_) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown || e.pointerId !== activePointerId) return;
      var dx = e.clientX - startX;
      if (!dragged && Math.abs(dx) > DRAG_THRESHOLD) dragged = true;
      if (dragged) {
        track.scrollLeft = startScrollLeft - dx;
        // Sample instantaneous velocity for the momentum handoff
        var now = performance.now();
        var dt = now - lastT;
        if (dt > 0) {
          velocity = (track.scrollLeft - lastScrollLeft) / dt;
        }
        lastT = now;
        lastScrollLeft = track.scrollLeft;
        e.preventDefault();
      }
    });

    function endDrag(e) {
      if (!isDown) return;
      if (e && activePointerId !== null && e.pointerId !== activePointerId) return;
      isDown = false;
      var wasDragged = dragged;
      dragged = false;
      activePointerId = null;

      track.style.scrollBehavior = prevScrollBehavior;
      if (e) {
        try { track.releasePointerCapture(e.pointerId); } catch (_) {}
      }

      if (wasDragged) {
        // Coast on the velocity captured during the last pointermove
        startMomentum();

        var blockClick = function (clickEvt) {
          clickEvt.stopPropagation();
          clickEvt.preventDefault();
        };
        track.addEventListener('click', blockClick, { capture: true, once: true });
        setTimeout(function () {
          track.removeEventListener('click', blockClick, true);
        }, 150);
      } else {
        track.classList.remove(DRAGGING_CLASS);
      }
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    // Block any native drag-and-drop so the browser doesn't hijack our sequence.
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  }

  function initVideoCard(wrap) {
    var video = wrap.querySelector('[data-ugc-video]');
    if (!video) return;

    var previewDuration = parseFloat(video.dataset.previewDuration) || 5;
    // 'idle' (poster), 'preview' (hover loop), 'playing' (full)
    var state = 'idle';

    // Lazy-attach the source so the carousel can host many video cards
    // without triggering any network fetches until the user interacts.
    function ensureSrc() {
      if (!video.getAttribute('src') && video.dataset.src) {
        video.src = video.dataset.src;
      }
    }

    function safeSeek(t) {
      try { video.currentTime = t; } catch (_) {}
    }

    function loopAtPreviewEnd() {
      if (video.currentTime >= previewDuration) {
        video.currentTime = 0;
      }
    }

    function startPreview() {
      if (state === 'playing') return;
      state = 'preview';
      wrap.classList.add('oddit-section-ugc-gallery__card-image-wrap--preview');
      ensureSrc();
      video.controls = false;
      video.muted = true;
      video.loop = false;
      safeSeek(0);
      video.addEventListener('timeupdate', loopAtPreviewEnd);
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    function stopPreview() {
      if (state === 'playing') return;
      state = 'idle';
      wrap.classList.remove('oddit-section-ugc-gallery__card-image-wrap--preview');
      video.removeEventListener('timeupdate', loopAtPreviewEnd);
      video.pause();
      safeSeek(0);
    }

    function playFull() {
      if (state === 'playing') return;
      state = 'playing';
      wrap.classList.remove('oddit-section-ugc-gallery__card-image-wrap--preview');
      wrap.classList.add('oddit-section-ugc-gallery__card-image-wrap--playing');
      ensureSrc();
      video.removeEventListener('timeupdate', loopAtPreviewEnd);
      video.loop = false;
      // Pause first so the upcoming play() is a fresh, gesture-initiated start.
      // Otherwise some browsers keep enforcing the muted-autoplay policy and
      // silently re-mute the still-playing preview when we flip muted to false.
      video.pause();
      safeSeek(0);
      video.controls = true;
      video.muted = false;
      video.volume = 1;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          // Browser blocked unmuted playback despite the gesture — fall back
          // to muted so the user at least sees the video.
          video.muted = true;
          video.play();
        });
      }
    }

    function returnToIdle() {
      state = 'idle';
      video.controls = false;
      wrap.classList.remove('oddit-section-ugc-gallery__card-image-wrap--playing');
      wrap.classList.remove('oddit-section-ugc-gallery__card-image-wrap--preview');
      safeSeek(0);
    }

    wrap.addEventListener('mouseenter', startPreview);
    wrap.addEventListener('mouseleave', stopPreview);
    wrap.addEventListener('click', playFull);
    video.addEventListener('ended', returnToIdle);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
